// extracted by mini-css-extract-plugin
export default {"wrapper":"SubHeader-wrapper-Nuq","container":"SubHeader-container-Uny","whiteIcons":"SubHeader-whiteIcons-nuR","headerStore":"SubHeader-headerStore-QuY"};